import React, { useEffect, useRef } from 'react';
import { FormGroup, ControlLabel, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Spinner from '../../../../../../components/Loaders/Spinner';

const PostImage = ({ isLoading, file, title, description, onDelete, onChange }) => {
  const inputFile = useRef(null)
  useEffect(() => {
    if (!isLoading) {
      inputFile.current.value = '';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading])

  return (
    <>
      <FormGroup>
        <Row>
          <Col md={10}>
            <FormGroup>
              <ControlLabel>{title}</ControlLabel>
              <input
                ref={inputFile}
                type="file"
                accept=".png, .jpg, .jpeg, .gif, .ico, .svg, .webp"
                onChange={onChange}
                disabled={isLoading}
              />
              <div className="post-form__file-description">{description}</div>
            </FormGroup>
          </Col>
          <Col md={2}>
            <div className="post-form__file-preview-container">
              <div className="position-relative">
                {isLoading
                  ? (
                    <div className={classNames('post-form__file-loader', {
                      'post-form__file-loader-wrapper': !!file,
                    })}
                    >
                      <Spinner />
                    </div>
                  ) : null}
                {file ? (
                  <div className="post-form__file-preview">
                    <img src={file.thumbnail_url || file.url} alt="Preview" className="img-thumbnail" />
                    {!isLoading
                      ? (
                        <div className="post-form__file-delete" onClick={onDelete}>
                          <i className="far fa-times" />
                        </div>
                      ) : null}
                  </div>
                ) : null}
              </div>
            </div>
          </Col>
        </Row>
      </FormGroup>
    </>
  );
}

PostImage.propTypes = {
  isLoading: PropTypes.bool,
  file: PropTypes.object,
  title: PropTypes.string,
  description: PropTypes.string,
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
};

export default PostImage;
